import { render, staticRenderFns } from "./auto_message.vue?vue&type=template&id=e8cf8378&scoped=true"
import script from "./auto_message.vue?vue&type=script&lang=js"
export * from "./auto_message.vue?vue&type=script&lang=js"
import style0 from "./auto_message.vue?vue&type=style&index=0&id=e8cf8378&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8cf8378",
  null
  
)

export default component.exports